import { AdminConsole } from "./components/AdminConsole";
import { WidgetShell } from "./components/WidgetShell";

function Landing() {
  return (
    <div className="landing-shell">
      <section className="landing-card">
        <p className="eyebrow">Cloudflare-native build</p>
        <h1>Text chatbot platform</h1>
        <p>
          This isolated app serves both the embedded widget route and the admin console. Open
          <code>/admin</code> for the dashboard or <code>/widget/demo-hotel</code> after seeding local data.
        </p>
      </section>
    </div>
  );
}

export default function App() {
  const path = window.location.pathname;
  if (path.startsWith("/widget/")) {
    const tenantSlug = decodeURIComponent(path.replace(/^\/widget\//, "").split("/")[0] || "");
    return <WidgetShell tenantSlug={tenantSlug} />;
  }

  if (path.startsWith("/admin")) {
    return <AdminConsole />;
  }

  if (path === "/") {
    return <Landing />;
  }

  return <Landing />;
}
